import React from "react";
import Catalogue from "./Catalogue";
import { getLocalisedCafeMedia } from "../../api/cafe";

const CafeCatalogue: React.FC = () => {
  return (
    <Catalogue getPaginatedMedia={getLocalisedCafeMedia} section_type="cafe" />
  );
};

export default CafeCatalogue;
